<template>
  <template v-if="view==='listar'">

    <button class="flex items-center px-2 py-1 text-white bg-teal-500 rounded-md hover:bg-teal-600 focus:outline-none"
        style="white-space: nowrap;"  @click="$emit('updateValues', {'view': 'reintegro_embargo'});$emit('data', data);"
    >
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-5 mr-1">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3" />
      </svg>

      Reintegros
    </button>

  </template>
</template>
<script>

export default {
  name: 'BotonReintegroEmbargoPersonaComponent',
  props: ['view', 'data'],
  emits: ['updateValues', 'data']
}
</script>
